import _ from 'lodash';

class PusherOddsConverter {
  convert(pusherOddsItem, existingOdds) {
    const type = this.determineType(pusherOddsItem.b.toLowerCase());
    let bookmaker;

    // We use the bid value only if we're dealing with BestOdds
    if (type === 'best') {
      bookmaker = pusherOddsItem.bid.toLowerCase();
    } else {
      bookmaker = pusherOddsItem.b.toLowerCase();
    }

    const newOddsItem = {};
    newOddsItem.selectionId = pusherOddsItem.sid;
    newOddsItem.type = type;
    newOddsItem.betType = this.convertBetType(pusherOddsItem.bt);
    newOddsItem.bookmakerId = bookmaker;

    newOddsItem.price = {
      value: parseFloat(pusherOddsItem.p),
      movement: this.calculateMovement(newOddsItem, parseFloat(pusherOddsItem.p), pusherOddsItem.f, existingOdds),
    };
    if (pusherOddsItem.hasOwnProperty('line') && pusherOddsItem.line !== null) {
      newOddsItem.line = {
        value: parseFloat(pusherOddsItem.line),
      };
    }

    return newOddsItem;
    // TODO: At some point will have to handle fluctuations as well, later though.
  }

  calculateMovement(oddsItem, price, fluctuations, existingOdds) {
    /*
     * If fluctuations array is not empty, get last fluctuation and calculate price movement
     * NOTE: Pusher doesn't send fluctuations currently
     */
    if (fluctuations.length) {
      const lastFluctuation = fluctuations.pop();
      const lastFluctuationPrice = parseFloat(lastFluctuation[1]);
      return Number((price - lastFluctuationPrice).toFixed(2));
    } else {
      // Attempt to find matching odds item and calculate movement that way
      const matchingOddsItem = _.find(existingOdds, {
        selectionId: oddsItem.selectionId,
        betType: oddsItem.betType,
        type: oddsItem.type,
        bookmakerId: oddsItem.bookmakerId,
      });

      if (matchingOddsItem) {
        return Number((price - matchingOddsItem.price.value).toFixed(2));
      }

      return 0;
    }
  }

  convertBetType(betType) {
    const betTypeMapping = {
      FixedWin: 'fixed-win',
      FixedPlace: 'fixed-place',
      DivWin: 'tote-win',
      DivPlace: 'tote-place',
      ExchangeBack: 'exchange-win',
      ExchangePlaceBack: 'exchange-place',
      ExchangeLay: 'exchange-win-lay',
      ExchangePlaceLay: 'exchange-place-lay',
    };

    if (betTypeMapping[betType]) {
      return betTypeMapping[betType];
    } else {
      return null;
    }
  }

  determineType(bookmakerId) {
    if (bookmakerId === 'average') {
      return 'average';
    } else if (bookmakerId === 'bestodds') {
      return 'best';
    } else {
      return 'bookmaker';
    }
  }
}

export default PusherOddsConverter;
